import React, { useState, PureComponent, useRef } from "react";
import { FadeLoader } from "react-spinners";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import "../App.css";
import Pagination from "react-js-pagination";
import Header from "./header";
import { DownloadTableExcel } from "react-export-table-to-excel";
import SideNav from "./sidenav";
import Action1 from "../assets/images/Action-1.png";
import { Button } from "react-bootstrap";
import Back from "../assets/images/arrow2.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { orderReportAction } from "../redux/actions/reportAction";
import { update } from "firebase/database";
const init = {
  orderReportFinalData: [],
};

const ReportOrder = () => {
  const tableRef = useRef(null);
  const [iState, updateState] = useState(init);
  const { orderReportFinalData } = iState;
  const dispatch = useDispatch();
  const [activePage, updateActivePage] = useState(1);
  const [serialNo, updateSerialNo] = useState(10);
  const { orderReportData, loader } = useSelector((state) => state.dashboard);

  const ownerData = JSON.parse(window.localStorage.getItem("ownerLogin"));
  useEffect(() => {
    dispatch(orderReportAction({ storeId: ownerData?._id }));
  }, []);

  useEffect(() => {
    updateState({
      ...iState,
      orderReportFinalData: orderReportData?.data?.result,
    });
  }, [orderReportData]);

  const handlePageChange = (pageNumber) => {
    let ser = pageNumber * 10;
    updateSerialNo(ser);
    updateActivePage(pageNumber);
    dispatch(orderReportAction({ storeId: ownerData?._id, page: pageNumber }));
  };

  return (
    <div>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FadeLoader color="#f56608" />
        </div>
      )}
      <Header />
      <SideNav />
      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
              <h4 class="Title">
                {" "}
                <Link to="/Report-management">
                  {" "}
                  <img src={Back} />
                </Link>{" "}
                Order Reports
              </h4>
            </div>
            <DownloadTableExcel
              filename="Orders Report List"
              sheet="Orders Report List"
              currentTableRef={tableRef.current}
            >
              <button className="DownloadExcel"> Export excel </button>
            </DownloadTableExcel>
            {/* <button className="DownloadExcel" >Export to Excel </button> */}
          </div>
          <div className="Small-Wrapper">
            <div class="TableList">
              <table ref={tableRef} style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Date</th>
                    <th>Customer Name</th>
                    <th>Billing Price</th>
                    <th>Discounted Price</th>
                    <th>Order Quantity</th>
                    <th>Mode of payment </th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {orderReportFinalData && orderReportFinalData?.length > 0 ? (
                    <>
                      {orderReportFinalData?.map((ele, index) => {
                        return (
                          <>
                            <tr>
                              <td>{ele?.orderNumber}</td>
                              <td>{ele?.createdAt?.split("T")[0]}</td>
                              <td>{ele?.userId?.fullName}</td>
                              <td>{ele?.paymentAmount}</td>
                              <td>{ele?.discountedAmount}</td>
                              <td>{ele?.orderData?.length}</td>
                              <td>{ele?.paymentMode}</td>
                              <td>
                                <span class="Orange">{ele?.status}</span>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={8}>No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div class="Pagination">
              <p>
                {" "}
                Total records :{" "}
                <span> {orderReportData?.data?.total || 0}</span>
              </p>
              <ul>
                {orderReportData?.data?.total > 0 && (
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={orderReportData?.data?.total || 0}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReportOrder;
